import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from '@app/core/services';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth-page.component.html',
  styleUrls: ['./auth-page.component.scss']
})
export class AuthPageComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isLoading = false;
  hasErrors = false;
  nextUri: string;
  ngUnsubscribe = new Subject();

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.authService.clearForumAuth();
    this.form = this.fb.group({
      email: ['', ],
      password: ['', ],
    });
    this.route.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(params => {
        this.nextUri = params['next'];
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  submit() {
    if (this.isLoading) return;

    this.isLoading = true;
    const url = decodeURIComponent(this.nextUri || '');
    const { email, password } = this.form.value;
    this.authService.login(email, password)
      .pipe(takeUntil(this.ngUnsubscribe))
      .finally(() => this.isLoading = false)
      .subscribe(user => user ? this.router.navigateByUrl(url || `/${user.user_type}/profile`) : null,
          error => this.hasErrors = !!error.error);
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/auth-page/auth-page.component.ts